import { JSX, useCallback } from "react";

import IconButton from "@mui/material/IconButton";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";

import DeleteIcon from "@mui/icons-material/Delete";

import IndexCheckbox from "utils/elements/IndexCheckbox";
import { ChangeEvent } from "utils/history/Event";

import { AdminRight } from "core/blueprint/trajectory/TrajectoryBlueprintService";
import { RoleRowProps } from "./RoleTable";

function AdminRoleRow(props: RoleRowProps): JSX.Element {
	const toggleRight = useCallback(
		(right: AdminRight, enabled: boolean): void => {
			const path = `/roles/${props.index}/adminRights/${right}`;
			props.onChange(new ChangeEvent(path, !enabled, enabled));
		},
		[props.index, props.role.adminRights, props.onChange]
	);

	const onDelete = useCallback((): void => {
		props.onDelete(props.index);
	}, [props.index, props.onDelete]);

	function hasRight(right: AdminRight): boolean {
		return props.role.adminRights[right] === true;
	}

	return (
		<TableRow>
			<TableCell component="th" scope="row">
				{props.role.name}
			</TableCell>
			<TableCell padding="checkbox" align="center">
				<IndexCheckbox
					index={AdminRight.PURCHASE}
					disabled={!props.editable}
					status={hasRight(AdminRight.PURCHASE)}
					onChange={toggleRight}
				/>
			</TableCell>
			<TableCell padding="checkbox" align="center">
				<IndexCheckbox
					index={AdminRight.METADATA}
					disabled={!props.editable}
					status={hasRight(AdminRight.METADATA)}
					onChange={toggleRight}
				/>
			</TableCell>
			<TableCell padding="checkbox" align="center">
				<IndexCheckbox
					index={AdminRight.RIGHTS}
					disabled={!props.editable}
					status={hasRight(AdminRight.RIGHTS)}
					onChange={toggleRight}
				/>
			</TableCell>
			<TableCell padding="none" align="right">
				<IconButton
					size="small"
					disabled={!props.editable}
					onClick={onDelete}>
					<DeleteIcon fontSize="inherit" />
				</IconButton>
			</TableCell>
		</TableRow>
	);
}

export default AdminRoleRow;
